import { store } from '@/store';
import { getModule } from 'vuex-module-decorators';
import HelpCenterStore from '@/help-center/store';
import LoanStore from '@/loan/store';
import { LoanAPIService } from '@/loan/services/api';

const helpCenterStore = getModule(HelpCenterStore, store);
const loanStore = getModule(LoanStore, store);

export const loanHelpCenterVersionsResolver = async (): Promise<void> => {
	const { isVersionsContentSet } = helpCenterStore;

	if (!isVersionsContentSet) {
		const content = await LoanAPIService.getHelpCenterVersionsContent();
		const { fiContactInfo } = loanStore;

		helpCenterStore.setVersionsContent(content);
		helpCenterStore.setFiContactInfo(fiContactInfo);
	}
};
